import { TranslationsContext } from '@teliaee/telia-translate';
import RoamingStore from '../../stores/RoamingStore';
import { inject, observer } from 'mobx-react';
import { Notice, Separator, Tabs, TabsItem, Text } from 'telia-front-react';
import * as React from 'react';
import { Segment } from '../../stores/SegmentStore';
import OperatorGeneralInfo from './OperatorGeneralInfo';
import GroupServiceTable from './services/GroupServiceTable';
import { CALLS_AND_MESSAGES_SERVICE_GROUP_ID, INTERNET_SERVICE_GROUP_ID } from '../RoamingInterfaces';
import ServiceGroupNotes from './services/ServiceGroupNotes';

interface SelectedOperatorProps {
  segment: Segment;
  roamingStore?: RoamingStore;
}

const SelectedOperator = (props: SelectedOperatorProps): JSX.Element => {
  const { translate } = React.useContext(TranslationsContext);
  const {
    roamingStore: { selectedCountry, selectedOperator, selectedOperatorServiceGroupById },
    segment,
  } = props;

  if (!selectedOperator) {
    return null;
  }
  const callsAndMessagesGroup = selectedOperatorServiceGroupById(CALLS_AND_MESSAGES_SERVICE_GROUP_ID);
  const internetGroup = selectedOperatorServiceGroupById(INTERNET_SERVICE_GROUP_ID);

  const getDefaultTab = (): string => {
    const tabInfo = {
      'calls-and-messages': callsAndMessagesGroup?.groupServices?.length,
      internet: internetGroup?.groupServices?.length,
    };

    return Object.entries(tabInfo).find(([_key, value]) => !!value)?.[0] || 'operator';
  };

  return (
    <>
      {selectedOperator.comment && (
        <>
          <Separator spacing="xsmall" color="invisible" />
          <Notice>{selectedOperator.comment}</Notice>
        </>
      )}
      <Separator spacing="small" color="invisible" />
      <Tabs aria-labelledby="price-info" defaultCurrentTab={getDefaultTab()} border="top">
        {!!callsAndMessagesGroup?.groupServices?.length && (
          <TabsItem id="calls-and-messages" icon="#phone-message" label={translate('roaming.operator.calls-and-messages')}>
            <Text>
              <GroupServiceTable segment={segment} serviceGroupId={CALLS_AND_MESSAGES_SERVICE_GROUP_ID} />
              <ServiceGroupNotes serviceGroupId={CALLS_AND_MESSAGES_SERVICE_GROUP_ID} type="calls" />
            </Text>
          </TabsItem>
        )}
        {!!internetGroup?.groupServices?.length && (
          <TabsItem id="internet" icon="#service-internet" label={translate('roaming.operator.internet')}>
            <Text>
              <GroupServiceTable segment={segment} serviceGroupId={INTERNET_SERVICE_GROUP_ID} />
              <ServiceGroupNotes serviceGroupId={INTERNET_SERVICE_GROUP_ID} type="internet" />
            </Text>
          </TabsItem>
        )}
        {selectedCountry?.isoCode !== 'RUS' && (
          <TabsItem id="operator" icon="#network" label={translate('roaming.operator')}>
            <OperatorGeneralInfo />
          </TabsItem>
        )}
      </Tabs>
    </>
  );
};

export default inject('roamingStore')(observer(SelectedOperator));
